import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const IpfsManagement = React.lazy(() => import("./IpfsManagement"));

const ipfsManagementModuleConfig: ModuleConfig = {
  // MODULE IDENTITY
  id: "local-private-ipfs-management",
  name: "Private IPFS",
  description: "Manage the private IPFS fleet — node storage/pin stats, per-tenant routing, and DO→Mac failover",
  version: "1.0.0",
  enabled: true,
  category: "administration",
  order: 96,
  icon: "🗄️",
  color: "#805AD5",

  // ROUTES — permissionLevel resolved from backend (local-private-ipfs-management)
  routes: [
    {
      path: "/admin/ipfs",
      component: IpfsManagement,
      permissionLevel: "view",
      useLayout: true,
    },
  ],

  // NAVIGATION
  navigation: [
    {
      label: "Private IPFS",
      path: "/admin/ipfs",
      icon: "🗄️",
      permissionLevel: "view",
    },
  ],

  // PERMISSIONS — backend is the single source of truth (empty arrays here)
  permissions: { view: [], create: [], edit: [], delete: [] },
};

export default ipfsManagementModuleConfig;
